import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z" />,
  'ChangeHistory',
);
